import { combineReducers } from 'redux'

import { configReducer } from 'client/store/config'
import { designReducer } from 'client/store/design'
import { facetReducer } from 'client/store/facet'
import { filterByCategoryReducer } from 'client/store/filterByCategory'
import { filterCategoriesReducer } from 'client/store/filterCategories'
import { filterByOptionReducer } from 'client/store/filterByOption'
import { filterOptionReducer } from 'client/store/filterOption'
import { filterReducer } from 'client/store/filter'
import { quickViewFilterReducer } from 'client/store/quickViewFilter'
import { pagingReducer } from 'client/store/paging'
import { productOptionsByProductKeyReducer } from 'client/store/productOptionsByProductKey'
import { refinementReducer } from 'client/store/refinement'
import { tileEntityReducer } from 'client/store/tileEntity'
import { uxReducer } from 'client/store/ux'
import { debugReducer } from 'client/store/debug'
import { experimentationReducer } from 'client/store/experimentation'
import { optionNameByFilterNameReducer } from 'client/store/optionNameByFilterName'
import { attributeNameByFilterNameReducer } from 'client/store/attributeNameByFilterName'
import { similarTemplatesReducer } from 'client/store/similarTemplates'
import { boostsReducer } from 'client/store/boosts'
import { authReducer } from 'client/store/auth'
import { designPersonalizationReducer } from 'client/store/designPersonalization'
import { previouslyOrderedReducer } from 'client/store/previouslyOrdered'
import { taxonomyIdByFilterNameReducer } from 'client/store/refinement/taxonomyIdByFilterName'
import { taxonomyIdByCategoryIdStateReducer } from 'client/store/taxonomyIdByCategoryId'
import { qvFilterNameByTaxonomyIdReducer } from 'client/store/qvFilterNameByTaxonomyId'
import { similarProductsReducer } from 'client/store/similarProducts'

/* eslint-disable @typescript-eslint/no-explicit-any */
//TODO MIGRATION T011: Fix eslint errors

export const rootReducer = combineReducers<State.GlobalState>({
  config: configReducer,
  debug: debugReducer,
  designs: designReducer,
  facets: facetReducer,
  filterByCategory: filterByCategoryReducer,
  filterByOption: filterByOptionReducer,
  optionNameByFilterName: optionNameByFilterNameReducer,
  attributeNameByFilterName: attributeNameByFilterNameReducer,
  filterCategories: filterCategoriesReducer,
  filterOptions: filterOptionReducer,
  filters: filterReducer,
  quickViewFilters: quickViewFilterReducer,
  paging: pagingReducer,
  previouslyOrdered: previouslyOrderedReducer,
  productOptionsByProductKey: productOptionsByProductKeyReducer,
  refinements: refinementReducer,
  tileEntities: tileEntityReducer,
  ux: uxReducer,
  experimentation: experimentationReducer,
  designPersonalization: designPersonalizationReducer,
  taxonomyIdByCategoryId: taxonomyIdByCategoryIdStateReducer,
  taxonomyIdByFilterName: taxonomyIdByFilterNameReducer,
  qvFilterNameByTaxonomyId: qvFilterNameByTaxonomyIdReducer,
  boosts: boostsReducer,
  authData: authReducer,
  similarTemplates: similarTemplatesReducer,
  similarProducts: similarProductsReducer,
} as any)
